<template>
  <div :class="isLeft ? 'floL' : 'floR'">
    <p
      class="fntH6 fntL bold marTML marBM" style="color:#2c2c2c; width:49%;"
      :style="isLeft ? { width: '49%' } : null"
    >{{ getFullTextByType(participant) }}</p>

    <!-- 참여 여부 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBM"
    >
      <p
        :class="{ moOnly: !isLeft }"
        class="fntP"
      >참여여부 <span class="ico-must-astar"></span></p>
      
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="Y"
              :name="`attendance-radio-${seq}`"
              :checked="participant.attendance_yn === 'Y'"
              :disabled="!infoAvailable"
              @change="selectAttendance"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">참여</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="N"
              :name="`attendance-radio-${seq}`"
              :checked="participant.attendance_yn === 'N'"
              :disabled="!infoAvailable"
              @change="selectAttendance"              
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">불참</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 이름 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-inFo-common pf23-lineBtm"
    >
      <label
        class="fntP"
        :for="`NCAcmi_name-${seq}`"
        :class="{ moOnly: !isLeft }"
      >이름 <span class="ico-must-astar"></span></label>
      <input
        type="text"
        size="50"
        maxlength="50"
        :id="`NCAcmi_name-${seq}`"
        :name="`NCAcmi_name${seq}`"
        :value="participant.name"
        :disabled="disabledByType || disabledByAttendance || !infoAvailable"
        @input="inputName(seq, $event.target.value)"
      />
    </div>

    <!-- ABO 번호 -->
    <div
      :class="isLeft ? 'pf23-inFo-L pf23-inFo-common' : 'pf23-inFo-blank01'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <template v-if="isLeft">
        <label
        class="fntP"
          :for="`NCAcmi_abo${seq}`"
        >ABO번호</label>
        <input
          type="text"
          disabled
          :id="`NCAcmi_abo${seq}`"
          :name="`NCAcmi_abo${seq}`"
          :value="participant.abo_uid"
        >
      </template>      
    </div>

    <!-- ADD : 휴대폰번호 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap">
        <label
          class="fntP"
          :for="`NCAcmi_mobile-${seq}`"
          :class="{ moOnly: !isLeft }"
        >휴대폰번호 <span class="ico-must-astar"></span>
        </label>
        010 -
        <input
          type="text"
          class="NCAcmi_num "
          size="50"
          maxlength="8"
          placeholder="- 없이 입력"
          :class="(participant.questions['Q200'].hasError && participant.questions['Q200'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q200'].raw_data"
          :id="`Q200-${seq}`"
          :disabled="disabledByAttendance || !infoAvailable"
          @input="inputNumberFixWordAnswer(seq, 'Q200', $event.target, 8)"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">
        <template v-if="(participant.questions['Q200'].hasError && participant.questions['Q200'].raw_data)">🚫 010 뒤의 숫자 8자리를 입력해주세요.</template>
      </p>
    </div>

    <!-- ADD : 내국인여부 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <label
        class="fntP"
        :for="`NCAcmi_domestic-${seq}`"
        :class="{ moOnly: !isLeft }"
      >내국인여부 <span class="ico-must-astar"></span>
      </label>
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="DOMESTIC"
              :id="`Q201-${seq}`"
              :name="`domestic-radio-${seq}`"
              :checked="participant.questions['Q201'].raw_data === 'DOMESTIC'"
              :disabled="disabledByAttendance || !infoAvailable"
              @change="inputRadioDomesticAnswer(`${seq}`, 'Q201', 'DOMESTIC'); inputSelectAnswer(`${seq}`, 'Q207', null, '대한민국');"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">내국인</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="FOREIGNER"
              :name="`domestic-radio-${seq}`"
              :checked="participant.questions['Q201'].raw_data === 'FOREIGNER'"
              :disabled="disabledByAttendance || !infoAvailable"
              @change="inputRadioDomesticAnswer(`${seq}`, 'Q201', 'FOREIGNER'); inputSelectAnswer(`${seq}`, 'Q207', null, '');"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">외국인</span>
          </label>
        </div>
      </div>
    </div>

    <!-- 주민등록번호 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          style="width:45%;"
          :for="`NCAcmi_personal01-${seq}`"
        >{{ participant.questions['Q201'].raw_data == 'FOREIGNER' ? '외국인등록번호' : '주민등록번호' }}<span class="ico-must-astar"></span>
        </label>
        <em class="txtR" style="width:55%;"
        ><input
          type="text"
          class="NCAcmi_num"
          style="width:45%; "
          maxlength="6"
          :id="`Q202-${seq}`"
          :name="`NCAcmi_personal${seq}-1`" 
          :class="(participant.questions['Q202'].hasError && participant.questions['Q202'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q202'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q201'].hasError"
          @input="inputJuminFirstNumber(seq, 'Q202', $event.target, false)"
        /><span class="disIb txtC" style="width:10%;">-</span
        ><input
          type="text"
          class="NCAcmi_num"
          style="width:45%; "
          maxlength="7"
          :id="`Q203-${seq}`"
          :name="`NCAcmi_personal${seq}-2`"
          :class="(participant.questions['Q203'].hasError && participant.questions['Q203'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q203'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q201'].hasError"
          @input="inputJuminLastNumber(seq, 'Q203', $event.target, 'Q206');"
        /></em>
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
        <template v-if="(participant.questions['Q202'].hasError || participant.questions['Q203'].hasError) && (participant.questions['Q202'].raw_data || participant.questions['Q203'].raw_data)">
        🚫 {{juminHasError}}
        </template>
      </p>
    </div>
    
    <!-- ADD : 성별 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <label
        :for="`NCAcmi_personal01-${seq}`"
        :class="{ moOnly: !isLeft }"
        class="fntP"
      >성별 <span class="ico-must-astar"></span>
      </label>
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="FEMALE"
              :id="`Q206-${seq}`"
              :name="`-radio-${seq}`"
              :checked="participant.questions['Q206'].raw_data === 'FEMALE'"
              :disabled="true"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">여성</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="MALE"
              :name="`sex-radio-${seq}`"
              :checked="participant.questions['Q206'].raw_data === 'MALE'"
              :disabled="true"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">남성</span>
          </label>
        </div>
      </div>
    </div>
    <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">* 주민/외국인 등록번호에 따라 자동선택됩니다.</p>

    <!-- ADD : 영문 성 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_engname01-${seq}`"
          :class="{ moOnly: !isLeft }"
        >여권 영문 성 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="30"
          placeholder="여권 영문 성"
          :id="`Q204-${seq}`"
          :name="`NCAcmi_engname01${seq}-1`" 
          :class="(participant.questions['Q204'].hasError && participant.questions['Q204'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q204'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          @input="inputEngAnswer(seq, 'Q204', $event.target)"          
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q204'].hasError && participant.questions['Q204'].raw_data)">🚫 2자 이상 영문으로 입력해주세요.</template></p>
    </div>
    
    
    <!-- ADD : 영문 이름 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_engname02-${seq}`"
          :class="{ moOnly: !isLeft }"
        >여권 영문 이름 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="30"
          placeholder="여권 영문 이름"
          :id="`Q205-${seq}`"
          :name="`NCAcmi_engname02${seq}-1`" 
          :class="(participant.questions['Q205'].hasError && participant.questions['Q205'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q205'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          @input="inputEngAnswer(seq, 'Q205', $event.target)"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="(participant.questions['Q205'].hasError && participant.questions['Q205'].raw_data)">🚫 2자 이상 영문으로 입력해주세요.</template></p>
    </div>

    <!-- ADD : 국가 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_personal01-${seq}`"
          :class="{ moOnly: !isLeft }"
        >국가 <span class="ico-must-astar"></span>
        </label>
        <div class="pf23-inFo-select pf23-country" >
          <select class="form-control" :value="participant.questions['Q207'].raw_data" 
            :id="`Q207-${seq}`"
            :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q201'].raw_data === 'DOMESTIC' "
            :class="ishint && participant.questions['Q207'].hasError ? 'check-red' : ''"
            @change="inputSelectAnswer(seq, 'Q207', $event.target)"
          >
            <option value="">국가선택</option>
            <template v-for="(country, index) in counties" >
              <option v-show="participant.questions['Q201'].raw_data !== 'DOMESTIC' && country.COUNTRY_KOR_NM !== '대한민국'" :value="country.COUNTRY_KOR_NM" :key="index" :checked="participant.questions['Q207'].raw_data == country.COUNTRY_KOR_NM">{{country.COUNTRY_ISO_WORD3}} - {{ country.COUNTRY_KOR_NM}}</option>
            </template> 
          </select>
        </div>
      </div>
      <p v-if="participant.questions['Q201'].raw_data === 'DOMESTIC'" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">* 내국인은 대한민국 자동 선택됩니다.</p>
      <p v-if="participant.questions['Q201'].raw_data !== 'DOMESTIC'" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q207'].hasError">🚫 국가를 선택해 주세요.</template></p>
    </div>
    
    <!-- ADD : 여권번호 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_passportnumber-${seq}`"
          :class="{ moOnly: !isLeft }"
        >여권번호 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="20"
          :id="`Q208-${seq}`"
          :name="`NCAcmi_passportnumber${seq}-1`" 
          :class="(participant.questions['Q208'].hasError && participant.questions['Q208'].raw_data) ? 'check-red' : ''"
          :value="participant.questions['Q208'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          @input="inputPassportAnswer(seq, 'Q208', $event.target)"
        />
      </div>
      <!--<p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;"><template v-if="(participant.questions['Q208'].hasError && participant.questions['Q208'].raw_data)">🚫 여권 번호를 입력해 주시기 바랍니다.</template></p>-->
    </div>

    <!-- ADD : 여권발급일 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_passportfrom${seq}`"
          :class="{ moOnly: !isLeft }"
        >여권발급일 <span class="ico-must-astar"></span>
        </label>
        <input
          type="date"
          class="NCAcmi_num"
          size="50"
          maxlength="50"
          :id="`Q209-${seq}`"
          :name="`NCAcmi_passportfrom${seq}`" 
          :class="ishint && participant.questions['Q209'].hasError ? 'check-red' : ''"
          :value="participant.questions['Q209'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          :max="today"
          @change="inputPassportDateAnswer(seq, 'Q209', $event.target)"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q209'].hasError">🚫 {{participant.questions['Q209'].remarks ? participant.questions['Q209'].remarks : "여권발급일을 선택해주세요."}}</template></p>
    </div>
    
    <!-- ADD : 여권만료일 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_passportend${seq}`"
          :class="{ moOnly: !isLeft }"
        >여권만료일 <span class="ico-must-astar"></span>
        </label>
        <input
          type="date"
          class="NCAcmi_num"
          size="50"
          maxlength="50"
          :id="`Q210-${seq}`"
          :name="`NCAcmi_passportend${seq}`" 
          :class="ishint && participant.questions['Q210'].hasError ? 'check-red' : ''"
          :value="participant.questions['Q210'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          :min="today"
          @change="inputPassportDateAnswer(seq, 'Q210', $event.target); navtiveAlert('여권 만료일은 출국일로부터 6개월 이상이어야 합니다.\n잔여 유효기간이 6개월 미만인 경우 여권을 재발급 받은 후 담당 여행사 (02-2022-6520)로 연락주시기 바랍니다.');"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;"><template v-if="ishint && participant.questions['Q210'].hasError">🚫 {{participant.questions['Q210'].remarks ? participant.questions['Q210'].remarks : "여권만료일을 선택해주세요."}}</template></p>
    </div>

    <!-- ADD : 신장 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_passportnumber-${seq}`"
          :class="{ moOnly: !isLeft }"
        >신장 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="3"
          placeholder="cm 단위"
          :id="`Q211-${seq}`"
          :name="`NCAcmi_passportnumber${seq}-1`" 
          :class="(ishint && participant.questions['Q211'].hasError) ? 'check-red' : ''"
          :value="participant.questions['Q211'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          @input="inputNumberAnswer(seq, 'Q211', $event.target)"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
        <template v-if="(ishint && participant.questions['Q211'].hasError)">
        🚫 신장을 입력해 주시기 바랍니다.</template>
      </p>
    </div>

    <!-- ADD : 체중 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`NCAcmi_passportnumber-${seq}`"
          :class="{ moOnly: !isLeft }"
        >체중 <span class="ico-must-astar"></span>
        </label>
        <input
          type="text"
          class="NCAcmi_num"
          size="50"
          maxlength="3"
          placeholder="kg 단위"
          :id="`Q212-${seq}`"
          :name="`NCAcmi_passportnumber${seq}-1`" 
          :class="(ishint && participant.questions['Q212'].hasError) ? 'check-red' : ''"
          :value="participant.questions['Q212'].raw_data"
          :disabled="disabledByAttendance || !infoAvailable"
          @input="inputNumberAnswer(seq, 'Q212', $event.target)"
        />
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">
        <template v-if="(ishint && participant.questions['Q212'].hasError)">
        🚫 체중을 입력해 주시기 바랍니다.</template>
      </p>
    </div>

    <!-- ADD : 신발사이즈 -->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`Q213-${seq}`"
          :class="{ moOnly: !isLeft }"
        >신발사이즈 <span class="ico-must-astar"></span>
        </label>
        <div class="pf23-inFo-select pf23-country" >
          <select class="form-control" :value="participant.questions['Q213'].raw_data" 
            :id="`Q213-${seq}`"
            :disabled="disabledByAttendance || !infoAvailable"
            :class="ishint && participant.questions['Q213'].hasError ? 'check-red' : ''"
            @change="inputSelectAnswer(seq, 'Q213', $event.target)"
          >
            <option value="">사이즈선택</option>
            <template v-for="(item, index) in shoeSize" >
              <option :value="item.CODE" :key="index" :checked="participant.questions['Q213'].raw_data == item.CODE">{{item.LABEL}}</option>
            </template> 
          </select>
        </div>
      </div>
      <p class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;height: 21px;">* 신발 사이즈 195mm 이하는 스키만 선택이 가능합니다.</p>
      <p v-if="(ishint && participant.questions['Q213'].hasError)" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫 신발사이즈를 선택해 주세요.</p>
    </div>

    <!-- ADD : 스키/보드 -->
    <div
      :class="isLeft ? 'pf23-inFo-L' : 'pf23-inFo-R'"
      class="padBSM padTSM pf23-lineBtm"
    >
      <label
        class="fntP"
        :for="`reports-radio-${seq}`"
        :class="{ moOnly: !isLeft }"
      >스키/보드 <span class="ico-must-astar"></span>
      </label>
      <div class="amway-theme" style="width:55%;">
        <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="스키"
              :id="`Q214-${seq}`"
              :name="`reports-radio-${seq}`"
              :checked="participant.questions['Q214'].raw_data === '스키'"
              :disabled="disabledByAttendance || !infoAvailable"
              @change="inputRadioAnswer(`${seq}`, 'Q214', '스키');"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">스키</span>
          </label>

          <label class="amw-radio-wrap radio-label focus">
            <input
              type="radio"
              class="amw-global-radio"
              value="보드"
              :name="`reports-radio-${seq}`"
              :checked="participant.questions['Q214'].raw_data === '보드'"
              :disabled="disabledByAttendance || !infoAvailable"
              @change="inputRadioAnswer(`${seq}`, 'Q214', '보드');"
            />
            <span class="amw-radio-overlay"></span>
            <span class="amw-label-radio-text">보드</span>
          </label>
        </div>
      </div>
    </div>

    <!-- ADD : 스키/보드 레벨-->
    <div class="padBSM padTSM pf23-inFo-common pf23-lineBtm pf23-inFo-blank03"
      :class="isLeft ? 'pf23-inFo-C' : 'pf23-inFo-C-R'">
      <div class="pf23-input-wrap-normal">
        <label
          class="fntP"
          :for="`Q215-${seq}`"
          :class="{ moOnly: !isLeft }"
        >스키/보드 레벨<span class="ico-must-astar"></span>
        </label>
        <div class="pf23-inFo-select pf23-country" >
          <select class="form-control" :value="participant.questions['Q215'].raw_data" 
            :id="`Q215-${seq}`"
            :disabled="disabledByAttendance || !infoAvailable || participant.questions['Q215'].raw_data === 'DOMESTIC' "
            :class="ishint && participant.questions['Q215'].hasError ? 'check-red' : ''"
            @change="inputSelectAnswer(seq, 'Q215', $event.target)"
          >
            <option value="">레벨선택</option>
            <template v-for="(item, index) in sportLevel" >
              <option :value="item.CODE" :key="index" :checked="participant.questions['Q215'].raw_data == item.CODE">{{item.LABEL}}</option>
            </template> 
          </select>
        </div>
      </div>
      <p v-if="(ishint && participant.questions['Q215'].hasError)" class="marTS fntE" style="color:#d91734; text-indent: -0.6em; padding-left: 0.6em;">🚫 레벨을 선택해 주세요.</p>
    </div>

    <!-- 여권 사본 -->
    <SurveyAttachment
      class="padBSM padTSM pf23-lineBtm"
      :id="`Q220-${seq}`"
      :participant="participant"
      :class="{ NCAcmi_last: participant.type === 'S' || (participant.type === 'P' && hideDocument) }"
      :sq-code="'Q220'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
    /> 

    <!-- 안전확인 동의서 -->
    <SurveyAttachmentCommon
      class="padBSM padTSM pf23-lineBtm"
      :id="`Q221-${seq}`"
      :participant="participant"
      :class="{ NCAcmi_blankR: hideDocument }"
      :sq-code="'Q221'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="hideDocument"
      :height="hideDocument ? null : `121px`"
      :display-right="hideDocument"      
    /> 

    <!-- 초상권 확인 동의서 -->
    <SurveyAttachmentCommon
      class="padBSM padTSM pf23-lineBtm"
      :id="`Q222-${seq}`"
      :participant="participant"
      :class="{ NCAcmi_blankR: hideDocument }"
      :sq-code="'Q222'"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :hide-btn="hideDocument"
      :height="hideDocument ? null : `121px`"
      :display-right="hideDocument"      

    /> 

    <!-- 배우자 참가 신청서  -->
    <SurveyAttachmentCommon
      v-if="existSpouse"
      class="padBSM padTSM pf23-lineBtm"
      :id="`Q224-${seq}`"
      :participant="participant"
      :class="{ NCAcmi_blankR: hideDocument }"
      :sq-code="'Q224'"
      :hide-btn="!hideDocument"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :height="hideDocument ? null : `121px`"
      :display-right="isLeft"
    />
    
    <!-- 가족관계 증명서  -->
    <SurveyAttachmentCommon
      v-if="needFamilyRelationDocument"
      class="padBSM padTSM pf23-lineBtm"
      :id="`Q225-${seq}`"
      :participant="participant"
      :class="{ NCAcmi_blankR: hideDocument }"
      :sq-code="'Q225'"
      :hide-btn="hideDocument"
      :disabled="disabledByAttendance || !infoAvailable"
      :is-left="isLeft"
      :height="hideDocument ? null : `198.19px`"
      :display-right="hideDocument"      
      >
      <template #outer>
        <p
          v-if="!hideDocument && isLeft"
          v-html="questions['Q225'].alert_text"
          class="marTS fntE"
          style="color:#0075a4; padding-left: 0.6em;"
        ></p>
        <p
          v-if="!hideDocument && !isLeft"
          v-html="questions['Q225'].alert_text"
          class="marTS fntE"
          style="color:#0075a4; padding-left: 0.6em;"
        ></p>
      </template>
    </SurveyAttachmentCommon>
  
    <!-- 안전확인 - mo 공동사업자 1, 모바일인 경우만 노출된다. PC 인 경우는 표시되지 않음-->
    <div class="padTSM moOnly pf23-lineBtm" v-if="isLeft">
      <p class="fntP">안전 확인<span class="ico-must-astar"></span></p>
      <p class="fntP padTSM ">‘안전확인동의서’ 에 ‘해당사항 있음’으로 체크한 항목이 있습니까? (임산부, 장애, 지병 및 기타 질병)</p>
    
      <div class="pf23-inFo-safe-L marTSM">
        <div class="amway-theme" style="width:55%;">
          <div class="action pf23-radioBtn radio-wrapper pf23-inFo-radio">
            <label class="amw-radio-wrap radio-label focus">
              <input type="radio" name="radio01-4" class="amw-global-radio" value="Y" 
                :id="`Q217-${seq}-FO`"
                :checked="participant.questions['Q217'].raw_data === 'Y'"
                :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                @change="inputRadioAnswer(`${seq}`, 'Q217', 'Y')" >
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">예</span>
            </label>
            <label class="amw-radio-wrap radio-label focus" style="margin-right:1.5em;">
              <input type="radio" name="radio01-4" class="amw-global-radio" value="N" 
                :checked="participant.questions['Q217'].raw_data === 'N'"
                :disabled="(!participant.attendance_yn || participant.attendance_yn === 'N') || !infoAvailable"
                @change="inputRadioAnswer(`${seq}`, 'Q217', 'N')" >
              <span class="amw-radio-overlay"></span>
              <span class="amw-label-radio-text">아니오</span>
            </label>
          </div>
        </div>
      </div>

      <p class="marTS fntE" style="color:#0075a4; text-indent: -0.6em; padding-left: 0.6em;">* 해당 사항이 있는 경우 반드시 상세 내용을 동의서 상에
        작성하여 주시기 바랍니다.</p> 
    </div>
  </div>
</template>

<script>
import SurveyAttachment from './SurveyAttachment.vue'
import SurveyAttachmentCommon from './SurveyAttachmentCommon.vue'
import { mapGetters, mapState } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import {
  SURVEY_SAPPORO,
  COMMON_QUESTIONS,
  SET_ATTENDANCE,
  ATTENDING_LIST,
  INFO_AVAILABLE,
  SPOUSE_ATTENDANTS,
  MEMBER_ATTENDANTS,
  NEED_FAMILY_RELATION_DOCUMENT,
  NEED_FAMILY_DOCUMENT,
  SET_FAMILY_ATTENDANCE_YN,
  CLEAR_RESPONSE_DATA,
  GET_CODE_COUNTRY,
  GET_CODE_TODAY,
  GET_CODE_PASSPORT_DATE,
  GET_CODE_SHOE_SIZE,
  GET_CODE_SPORT_LEVEL,
} from '@/store/actions/survey'

export default {
  name: 'SurveyParticipant',
  mixins: [CommonMethodMixin],
  components: {
    SurveyAttachment,
    SurveyAttachmentCommon
  },
  props: {
    seq: {
      type: Number,
      required: true
    },
    participant: {
      type: Object,
      required: true
    },
  },
  computed: {
    ...mapState(SURVEY_SAPPORO, {
      hint: state => state.hint,
    }),
    ...mapGetters(SURVEY_SAPPORO, {
      attendingList: ATTENDING_LIST,
      questions: COMMON_QUESTIONS,
      infoAvailable: INFO_AVAILABLE,
      needFamilyRelationDocument: NEED_FAMILY_RELATION_DOCUMENT,
      needFamilyDocument: NEED_FAMILY_DOCUMENT,
      spouseAttendants: SPOUSE_ATTENDANTS,
      memberAttendants: MEMBER_ATTENDANTS,
      counties : GET_CODE_COUNTRY,
      today: GET_CODE_TODAY,
      passportDate: GET_CODE_PASSPORT_DATE,
      shoeSize: GET_CODE_SHOE_SIZE,
      sportLevel: GET_CODE_SPORT_LEVEL,
    }),
    isLeft() {
      return this.seq % 2 === 0;
    },
    disabledByType() {
      return this.participant.type === 'E' || this.participant.type === 'P';
    },
    disabledByAttendance() {
      return !this.participant.attendance_yn || this.participant.attendance_yn === 'N';
    },
    isSole() {
      return this.participant.type === 'E';
    },
    existSpouse() {
      return this.spouseAttendants.length > 0;
    },
    existMember() {
      return this.memberAttendants.length > 0;
    },
    isFirstParty() {
      if(!this.existMember && this.participant.type === 'P' && this.participant.type_seq === 1) {
        return true;
      } else {
        const firstParty = this.attendingList.filter(attendant => attendant.type === 'P').sort((a, b) => a.type_seq - b.type_seq)[0];
        return firstParty ? (firstParty.type === this.participant.type && firstParty.type_seq === this.participant.type_seq) : false;
      }
    },
    hideDocument() {
      return !(this.isSole || this.isFirstParty);
    },
    ishint () {
      return !this.disabledByAttendance && this.infoAvailable && this.hint
    },
    juminHasError() { 
        const firstError = this.participant.questions['Q202'].hasError;
        const secondError = this.participant.questions['Q203'].hasError;
        const domestic = this.participant.questions['Q201'].hasError;

        if (domestic) { 
          return "내/외국인 여부를 선택해 주세요."
        } else if (firstError && this.participant.questions['Q202'].remarks) { 
          return this.participant.questions['Q202'].remarks;
        } else if (secondError && this.participant.questions['Q203'].remarks) { 
          return this.participant.questions['Q203'].remarks;
        } else if (firstError || secondError) { 
          return "숫자 13자리를 입력해주세요."
        }
    },
  },
  methods: {
    selectAttendance(e) {
      const attendance_yn = e.target.value;
      this.$store.commit(`${SURVEY_SAPPORO}/${SET_ATTENDANCE}`, { idx: this.seq, attendance_yn });
      if(attendance_yn === 'N') {
        if(!this.existMember) {
          this.$store.commit(`${SURVEY_SAPPORO}/${SET_FAMILY_ATTENDANCE_YN}`, attendance_yn);
          console.log("[동반가족 불참처리]")
        }
        // this.$store.dispatch(`${SURVEY_SAPPORO}/${CLEAR_RESPONSE_DATA}`, this.seq);
      }
    },
    navtiveAlert(msg){
      window.alert(msg);
    }
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sapporo/components/SurveyParticipant.vue